import React, { useState } from 'react';
import { Icon, Textarea } from '@thinkific/toga-react';
import Button, { ButtonWithIconOnly } from 'koba/components/Button';
import Modal from 'koba/components/Modal';
import ModalBody from 'koba/components/Modal/ModalBody';
import ModalHeader from 'koba/components/Modal/ModalHeader';
import { Attachment } from 'schema/Post/types';
import { TFunction } from 'i18next';
import styles from './AltTextModal.module.scss';

interface AltTextModalProps {
  attachment: Attachment | null;
  submitAltText: (altText: string) => void;
  onClose: () => void;
  t: TFunction;
  primaryColor: string;
}

const AltTextModal = ({
  attachment,
  onClose,
  submitAltText,
  t,
  primaryColor,
}: AltTextModalProps) => {
  if (!attachment) return null;
  const { altText = '', url } = attachment;
  const [altTextValue, setAltTextValue] = useState(altText);

  return (
    <Modal
      closeModal={() => {}}
      footer={
        <>
          <Button appearance="ghost" onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button
            appearance="default"
            color={primaryColor}
            onClick={() => submitAltText(altTextValue)}
          >
            {t('Done')}
          </Button>
        </>
      }
      isFullWidth
      isOpen
    >
      <ModalHeader
        className={styles['alt-text-modal__header']}
        data-qa="alt-text-modal-header"
        hasTitle
      >
        <span className={styles['alt-text-modal__title']}>
          {t('communities_components-altTextModal-alt_text', 'Alt Text')}
        </span>
        <ButtonWithIconOnly
          appearance="knockout"
          ariaLabel={t('Close modal')}
          data-qa="close-modal"
          id="close-modal"
          onClick={onClose}
        >
          <Icon className="" name="x-dismiss" />
        </ButtonWithIconOnly>
      </ModalHeader>
      <ModalBody
        className={styles['alt-text-modal__body']}
        hasTitle
        isFullWidth
      >
        <img
          alt="Preview"
          className={styles['alt-text-modal__image']}
          src={url}
        />
        <div className={styles['alt-text-modal__textarea-container']}>
          <Textarea
            id="alt-text"
            label={t(
              'communities_components-altTextModal-descriptive_alt_text',
              'Descriptive alt text'
            )}
            value={altTextValue}
            onChange={(e) => setAltTextValue(e.target.value)}
          />
          <span className={styles['alt-text-modal__description']}>
            {t(
              'communities_components-altTextModal-descriptive_alt_text',
              'Alternative text describes your image to people with visual impairments'
            )}
          </span>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AltTextModal;
